import React from "react"
import CV from "../../assets/Rufat Mammadyarov Resume.pdf"

const CTA = () => {
  return (
    <div className="cta">
      <a href={CV} download className="btn">
        Resume
      </a>
      <a href="#contact" className="btn btn-primary">
        Let's talk
      </a>
    </div>
  )
}

export default CTA
